import loadable from "@loadable/component";
import {SelfServicesPermissions} from "../../../permissions/SelfServices.Permissions";

const ScoreCardView = loadable(() =>
    import("../../../Views/Home/scorecards/Scorecard.View")
);
const InternalVacanciesView = loadable(() =>
  import("../../../Views/Home/internal-vacancies/InternalVacancies.View")
);
const JobsView = loadable(() =>
  import("../../../Views/Home/internal-vacancies-old/Jobs.View")
);
const JobsTrackingView = loadable(() =>
  import("../../../Views/Home/job-tracking/JobsTracking.View")
);

const SharedJobsView = loadable(() =>
  import("../../../Views/Home/internal-vacancies-old/tabs/SharedJobs.View")
);
const SelfServiceView = loadable(() =>
  import("../../../Views/Home/self-service/SelfService.View")
);
const MyProfileView = loadable(() =>
  import("../../../Views/Home/my-profile/MyProfile.View")
);
// const MyProfileManagementView = loadable(() =>
//   import(
//     "../../../Views/Home/my-profile/profile-management/MyProfileManagement.View"
//   )
// );
const ApprovalsTrackingView = loadable(() =>
  import("../../../Views/Home/approvals-tracking/ApprovalsTracking.View")
);
const JobRequisitionView = loadable(() =>
  import("../../../Views/Home/job-requisition/JobRequisition.View")
);
const JobRequisitionRequestView = loadable(() =>
  import(
    "../../../Views/Home/job-requisition/job-requisition-request/JobRequisitionRequest.View"
  )
);
const JobDetailsView = loadable(() =>
  import("../../../Views/Home/job-candidates-details/JobCandidatesDetails.View")
);

const AssessmentCandidatesDetailsView = loadable(() =>
  import("../../../Views/Home/assessment-candidates-details/AssessmentCandidatesDetails.View")
);

const PrepAssessmentRedirectView = loadable(() =>
  import("../../../Views/Home/assessment-candidates-details/PrepAssessmentRedirect.View")
);

const VisaAllRequestsView = loadable(() =>
  import("../../../Views/Home/visa/visa-all-requests/VisaAllRequests.View")
);

const MyTasksView = loadable(() =>
  import("../../../Views/Home/tasks/Tasks.View")
);

export const HomeRoutes = [
  {
    id: 1,
    path: "self-service",
    name: "Shared:self-service",
    component: SelfServiceView,
    layout: "/home",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 2,
    path: "my-profile",
    name: "Shared:my-profile",
    component: MyProfileView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 3,
    path: "approvals-tracking",
    name: "Shared:approvals-tracking",
    component: ApprovalsTrackingView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 4,
    path: "internal-vacancies",
    name: "Shared:internal-vacancies",
    component: InternalVacanciesView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
    // defaultPermissions: SelfServicesPermissions,
    // permissionId: SelfServicesPermissions.InternalVacancies.key,
  },
  {
    id: 4,
    path: "jobs",
    name: "Shared:internal-vacancies",
    component: JobsView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
    defaultPermissions: SelfServicesPermissions,
    permissionId: SelfServicesPermissions.InternalVacancies.key,
  },
  {
    id: 5,
    path: "job-requisition",
    name: "Shared:job-requisition",
    component: JobRequisitionView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 6,
    path: "job-requisition-request",
    name: "Shared:job-requisition",
    component: JobRequisitionRequestView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  // {
  //   id: 7,
  //   path: "my-profile-management",
  //   name: "Shared:my-profile-management",
  //   component: MyProfileManagementView,
  //   layout: "/home",
  //   default: false,
  //   isRoute: true,
  //   authorize: true,
  //   roles: [],
  //   icon: "mdi mdi-notebook-check-outline",
  //   isDisabled: false,
  //   isRecursive: false,
  //   isExact: true,
  //   children: [],
  // },
  {
    id: 8,
    path: "job-candidates-details",
    name: "Shared:job-details",
    component: JobDetailsView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline", // TODO: Diana : Change later
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 14,
    path: "assessment-candidates-details",
    name: "Shared:job-details",
    component: AssessmentCandidatesDetailsView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 15,
    path: "prep-assessment-details",
    name: "Shared:job-details",
    component: PrepAssessmentRedirectView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-notebook-check-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 9,
    path: "visa-requests",
    name: "Shared:visa-requests",
    component: VisaAllRequestsView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-ticket-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 10,
    path: "shared-resume",
    name: "Shared:shared-resumes",
    component: SharedJobsView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-ticket-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 11,
    path: "tasks",
    name: "Shared:my-tasks",
    component: MyTasksView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-ticket-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 12,
    path: "jobs-tracking",
    name: "Shared:job-tracker",
    component: JobsTrackingView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-ticket-outline",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
  {
    id: 13,
    path: "scorecards",
    name: "Shared:scorecards",
    component: ScoreCardView,
    layout: "/home",
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    icon: "mdi mdi-card",
    isDisabled: false,
    isRecursive: false,
    isExact: true,
    children: [],
  },
];
